import { animate, stagger, timeline } from 'motion';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import throttle from 'lodash.throttle';

const Navigation = () => {
  const navBar = document.getElementById('page-navbar');
  const navEl = document.getElementById('page-navbar-sidebar');
  // const navOverflowEl = document.querySelector('.side-nav-overflow-wrapper');
  const navOverflowEl = document.querySelector('.mobile-side-nav-overflow-wrapper');
  const navItemEls = navEl?.querySelectorAll('.nav-item-js');

  /* Button nav trigger */
  document.addEventListener('nav:toggle', (e) => {
    if (e.detail) {
      openNav();
    } else {
      closeNav();
    }
  });

  /* Navbar hide on scroll */
  let lastScrollTop = 0;
  const navToggleOffset = document.querySelector('.giantpeach-banner')?.offsetHeight ?? window.innerHeight;

  const openNav = () => {
    const modalOverflowElements = document.querySelectorAll('.modal-overflow');

    document.body.classList.add('nav-open');

    disableBodyScroll(navOverflowEl);
    modalOverflowElements.forEach(el => {
      disableBodyScroll(el);
    });

    timeline([
      [navEl, { opacity: 1, visibility: 'visible' }, { duration: 0.3, easing: [0.25, 0.1, 0.25, 1] }],
      [
        navItemEls,
        { opacity: 1 },
        { duration: 0.3, delay: stagger(0.1), easing: [0.25, 0.1, 0.25, 1], at: '-0.2' },
      ],
    ]);
  };

  const closeNav = (duration = 0.3) => {
    document.body.classList.remove("nav-open");
    clearAllBodyScrollLocks();

    timeline([
      [
        navEl,
        { opacity: 0, visibility: 'hidden' },
        { duration: duration, easing: [0.25, 0.1, 0.25, 1] },
      ],
      [
        navItemEls,
        { opacity: 0 },
        {
          duration: duration,
          easing: [0.25, 0.1, 0.25, 1],
        },
      ],
    ]);
  };

  closeNav(0);
};

export default Navigation;
